export const topics = [
  { id: 1, name: '长相思第二季', heat: '982万', trend: 'up', icon: 'ri-fire-line' },
  { id: 2, name: '奔跑吧2026', heat: '756万', trend: 'up', icon: 'ri-fire-line' },
  { id: 3, name: '周深演唱会', heat: '641万', trend: 'up', icon: 'ri-fire-line' },
  { id: 4, name: '金鸡奖提名', heat: '523万', trend: 'up', icon: 'ri-arrow-up-line' },
  { id: 5, name: '某顶流恋情', heat: '489万', trend: 'new', icon: 'ri-sparkling-line' },
  { id: 6, name: '暑期档票房', heat: '412万', trend: 'up', icon: 'ri-arrow-up-line' },
  { id: 7, name: '披荆斩棘阵容', heat: '378万', trend: 'up', icon: 'ri-arrow-up-line' },
  { id: 8, name: '短剧行业洗牌', heat: '295万', trend: 'new', icon: 'ri-sparkling-line' },
  { id: 9, name: '国际大刊封面', heat: '267万', trend: 'up', icon: 'ri-arrow-up-line' },
  { id: 10, name: '长安十二时辰电影', heat: '234万', trend: 'new', icon: 'ri-sparkling-line' },
];